export default function usePreviewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('internalPreview') === 'true';
}
